var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadDrop2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Solid",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.551,
    height: 17.551,
    viewBox: "0 0 17.551 17.551",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4538",
    "data-name": "Path 4538",
    d: "M133.654,145.18l-3.424-3.424a.908.908,0,0,0-1.284,1.284l1.874,1.874h-9.912a.908.908,0,0,0,0,1.816h9.912l-1.874,1.874a.908.908,0,1,0,1.284,1.284l3.424-3.424A.908.908,0,0,0,133.654,145.18Z",
    transform: "translate(-116.369 -137.046)",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4539",
    "data-name": "Path 4539",
    d: "M34.591,37.92a.908.908,0,0,0-.908.908v.908H25.816V25.816h7.868v.908a.908.908,0,1,0,1.816,0v-1.21A1.513,1.513,0,0,0,33.986,24H25.513A1.513,1.513,0,0,0,24,25.513V40.038a1.513,1.513,0,0,0,1.513,1.513h8.473A1.513,1.513,0,0,0,35.5,40.038v-1.21A.908.908,0,0,0,34.591,37.92Z",
    transform: "translate(-24 -24)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadDrop2);
export default __webpack_public_path__ + "static/media/head-drop2.7493847fd695f84f9bd3c2a7aeb2f7bd.svg";
export { ForwardRef as ReactComponent };